import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { keyBy, each, uniq } from 'lodash';
import Fa from 'react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

import styles from './styles.css';

// order master!
const PRICES = [
  {
    value: 'Similar',
    cls: 'warning',
  }, 
  {
    value: 'Higher',
    cls: 'danger',
  }, 
  {
    value: 'Lower',
    cls: 'success',
  },
  /*
  {
    value: 'NA',
    cls: 'default',
  },
  */
];

class MasterPricePositionRenderer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.requestShowFeedbacks = this.requestShowFeedbacks.bind(this);
  }

  requestShowFeedbacks() {
    this.props.requestShowFeedback(this.props.mode, this.props.data, true);
  }

  renderValue() {
    const { data, field } = this.props;
    if (!data) {
      return null;
    }
    const value = data[field];
    if (!value || value === undefined) {
      return <Fa name="spinner" spin className="text-muted" />;
    }
    const allPrices = keyBy(value, 'label');
    return (
      <div className={styles.prices}>
        {PRICES.map((price) => {
          if (!allPrices[price.value]) {
            return null;
          }
          const { label } = allPrices[price.value];
          const contacts = uniq(allPrices[price.value].contacts);
          const total = contacts.length;
          let contactStr = '';
          each(contacts, (contact, i) => {
            const prefix = (total > 1 && i === total - 1) ? ' and ' : '';
            const suffix = (i < total - 2) ? ', ' : '';
            contactStr += `${prefix}${contact}${suffix}`;
          });
          const tip = (
            <Tooltip id={`price-position-${label}`}>
              <div>{contactStr} indicated your price was {label}</div>
            </Tooltip>
          );
          return (
            <OverlayTrigger key={label} trigger={['hover', 'focus']} placement="top" overlay={tip}>
              <span 
                style={{ cursor: 'pointer' }} 
                onClick={this.requestShowFeedbacks} 
                className={`label label-${price.cls} ${styles.label}`}
              >
                {label}
              </span>
            </OverlayTrigger>
          );
        })}
      </div>
    );
  }

  render() {
    const isGrouped = this.props.node && this.props.node.group;
    if (!isGrouped) {
      return this.renderValue();
    }
    return null;
  }
}


MasterPricePositionRenderer.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  field: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  data: PropTypes.shape({
    feedbacks: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }).isRequired,
  requestShowFeedback: PropTypes.func,
};
MasterPricePositionRenderer.defaultProps = {
  value: null,
  data: {},
  requestShowFeedback: () => {},
};

export default MasterPricePositionRenderer;
